import { Component, OnInit } from '@angular/core';
import { Transaction } from '@app/@shared/models/transaction.model';
import { LoadingController, ModalController, NavController, ToastController } from '@ionic/angular';
import { SorteoService } from '@app/@shared/services/sorteo.service';
import { Wallet } from '@app/@shared/models/wallet.model';
import { PayoutService } from '@app/@shared/services/payout.service';

interface AmountUsed {
  type: string;
  amount: number;
}

@Component({
  selector: 'app-wallet-transaction-detail',
  templateUrl: './wallet-transaction-detail.component.html',
  styleUrl: './wallet-transaction-detail.component.scss',
})
export class WalletTransactionDetailComponent implements OnInit {
  transaction?: Transaction;
  created?: Date;
  type = '';
  reason = '';
  refund = false;
  isTradicional = false;
  tickets: any[] = [];
  sorteoS?: SorteoService;
  product = '';
  touches: string[] = [];
  selected = 'loteria';
  balanceStart = 0;
  balanceEnd = 0;
  awardBalanceStart = 0;
  awardBalanceEnd = 0;
  bonusBalanceStart = 0;
  bonusBalanceEnd = 0;
  wallets: Wallet[] = [];
  sbStake?: number | null;

  amounts: AmountUsed[] = [];
  payoutS?: PayoutService;

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private navCtrl: NavController,
    private toastCtrl: ToastController
  ) {}

  ngOnInit(): void {
    if (this.transaction && this.transaction.data) {
      if (typeof this.transaction.data === 'string') {
        this.transaction.data = JSON.parse(this.transaction.data);
      }
      const { data } = this.transaction;
      if (this.type === 'purchase') {
        this.product = this.transaction?.type.split('wallet-purchase-').pop() || '';
      } else if (this.type === 'refund') this.product = this.transaction?.type.split('wallet-refund-').pop() || '';

      this.isTradicional = data.type === 'sorteo';
      this.tickets = Array.isArray(data.tickets) ? (this.product === 'Tris' ? data.trisTickets : data.tickets) : [];
      this.touches = data.touches;

      const dataToKey = data.cancelled
        ? data.cancelled.payload
        : data.pending
        ? data.pending.payload
        : data.confirm
        ? data.confirm.payload
        : undefined;

      if (dataToKey) {
        this.reason = dataToKey.Reason || '';
      }
      if (data.product === 'book') {
        this.sbStake = data?.wager?.riskAmount ?? null;
      }
      const {
        balanceEnd,
        balanceStart,
        awardBalanceEnd,
        awardBalanceStart,
        bonusBalanceEnd,
        bonusBalanceStart,
        walletsUsed,
      } = data;
      //console.log(this.transaction);

      const wallet = this.wallets.find((w) => w.id === this.transaction?.walletId.id);
      const isBonusWallet = wallet?.walletName.includes('bonus');

      if (typeof bonusBalanceStart === 'number' && typeof bonusBalanceEnd === 'number') {
        this.bonusBalanceEnd = bonusBalanceEnd;
        this.bonusBalanceStart = bonusBalanceStart;
      } else if (isBonusWallet && typeof balanceStart === 'number' && typeof balanceEnd === 'number') {
        this.bonusBalanceEnd = balanceEnd;
        this.bonusBalanceStart = balanceStart;
      }

      if (typeof awardBalanceStart === 'number' && typeof awardBalanceEnd === 'number') {
        this.awardBalanceEnd = awardBalanceEnd;
        this.awardBalanceStart = awardBalanceStart;
      }

      if (typeof balanceStart === 'number' && typeof balanceEnd === 'number' && !isBonusWallet) {
        this.balanceEnd = balanceEnd;
        this.balanceStart = balanceStart;
      }

      if (Array.isArray(walletsUsed)) {
        this.amounts = walletsUsed
          .map((wu: { id: string; amount: number }) => {
            const wallet = this.wallets.find((w) => w.id === wu.id);
            const type = wallet?.walletName.includes('bonus')
              ? 'bonus'
              : wallet?.walletName.includes('award')
              ? 'award'
              : 'loteria';

            return {
              amount: wu.amount,
              type,
            };
          })
          .reduce((a, b) => {
            if (a.some((au) => au.type === b.type)) {
              return a.map((au) =>
                au.type === b.type
                  ? {
                      type: au.type,
                      amount: au.amount + b.amount,
                    }
                  : au
              );
            }
            return [...a, b];
          }, [] as AmountUsed[]);
      } else {
        const wallet = this.wallets.find((w) => w.id === this.transaction?.walletId.id);
        const type = wallet?.walletName.includes('bonus')
          ? 'bonus'
          : wallet?.walletName.includes('award')
          ? 'award'
          : 'loteria';

        this.amounts.push({
          amount: this.transaction.amount,
          type,
        });
      }
    }
  }

  close(role?: string) {
    this.modalCtrl.dismiss(role);
  }

  async goToPurchase(t: Transaction) {
    let uid = '';
    //console.log(t);

    if (t.type === 'wallet_prize_award') {
      uid = t.purchase as string;
    } else {
      uid = t.uid as string;
    }

    //console.log(uid);
    this.navCtrl.navigateForward(['/', 'payment', uid], {
      queryParams: {
        fromHistory: true,
      },
    });
    this.close();
  }

  gotoHistory() {
    this.navCtrl.navigateForward(['/', 'purchase-history'], {});
    this.close();
  }

  getName(drawName: string) {
    const gameTypes = [
      { type: 'progol', label: 'Progol' },
      { type: 'progolmedia', label: 'Progol Media Semana' },
      { type: 'gana-gato', label: 'Gana Gato' },
      { type: 'melate', label: 'Melate' },
      { type: 'melate-retro', label: 'Melate Retro' },
      { type: 'tris', label: 'Tris' },
      { type: 'chispazo', label: 'Chispazo' },
      { type: 'prono-sports', label: 'PronoSports' },
      { type: 'protouch', label: 'Protouch' },
      { type: 'zodiaco', label: 'Sorteo zodiaco' },
      { type: 'zodiaco-especial', label: 'Sorteo zodiaco especial' },
      { type: 'mayor', label: 'Sorteo mayor' },
      { type: 'superior', label: 'Sorteo superior' },
      { type: 'gran-especial', label: 'Sorteo gran Especial' },
      { type: 'magno', label: 'Sorteo magno' },
      { type: 'especial', label: 'Sorteo especial' },
      { type: 'gordito', label: 'Sorteo gordito de navidad' },
    ];

    const matchName = gameTypes.find((item) => item.type === drawName.toLocaleLowerCase());

    return matchName?.label;
  }
  async copy(str: string) {
    let error = false;
    try {
      await navigator.clipboard.writeText(str);
    } catch (error) {
      console.error(error);
      error = true;
    } finally {
      const otast = await this.toastCtrl.create({
        message: error ? `Error al copiar al portapapeles` : `${str} copiado al portapapeles existosamente`,
        duration: 3000,
        buttons: [{ icon: 'close' }],
      });

      await otast.present();
    }
  }

  getDigits(numeroBillete: number | string, drawType: string): number[] {
    if (numeroBillete == null) return [];

    const numeroStr = numeroBillete.toString();
    const configSorteo = this.sorteoS?.digitsSign.find((sorteo) => sorteo.nombreSorteo === drawType);

    if (!configSorteo) {
      console.warn(`No se encontró configuración para el sorteo: ${drawType}`);
      return numeroStr.split('').map(Number);
    }

    const digitosRequeridos = configSorteo.digitosBillete;
    const numeroFormateado = numeroStr.padStart(digitosRequeridos, '0');

    return numeroFormateado.split('').map(Number); // Ej: [0, 2, 5, 6]
  }

  getZodiacIcon(signo: number): string {
    const iconMap: { [key: string]: string } = {
      ARIES: 'assets/icons/zodiac/game-icons_aries.svg',
      TAURO: 'assets/icons/zodiac/game-icons_taurus.svg',
      GÉMINIS: 'assets/icons/zodiac/game-icons_gemini.svg',
      CÁNCER: 'assets/icons/zodiac/game-icons_cancer.svg',
      LEO: 'assets/icons/zodiac/game-icons_leo.svg',
      VIRGO: 'assets/icons/zodiac/game-icons_virgo.svg',
      LIBRA: 'assets/icons/zodiac/game-icons_libra.svg',
      ESCORPIÓN: 'assets/icons/zodiac/game-icons_scorpio.svg',
      SAGITARIO: 'assets/icons/zodiac/game-icons_sagittarius.svg',
      CAPRICORNIO: 'assets/icons/zodiac/game-icons_capricorn.svg',
      ACUARIO: 'assets/icons/zodiac/game-icons_aquarius.svg',
      PISCIS: 'assets/icons/zodiac/game-icons_pisces.svg',
    };
    const signoNombre = this.getZodiacName(signo);
    return iconMap[signoNombre] || '';
  }

  getZodiacName(signo: number): string {
    const signosZodiacales: { [key: number]: string } = {
      1: 'ARIES',
      2: 'TAURO',
      3: 'GÉMINIS',
      4: 'CÁNCER',
      5: 'LEO',
      6: 'VIRGO',
      7: 'LIBRA',
      8: 'ESCORPIÓN',
      9: 'SAGITARIO',
      10: 'CAPRICORNIO',
      11: 'ACUARIO',
      12: 'PISCIS',
    };
    return signosZodiacales[signo] || '';
  }

  async payoutReviver(t: Transaction) {
    if (!this.payoutS) return;

    const loading = await this.loadingCtrl.create({
      message: 'Cargando',
    });

    await loading.present();

    // const data = await this.payoutS.reviverPayout(t.uid!);
    this.close('reviver');

    await loading.dismiss();
  }

  get bookWaggers() {
    if (this.transaction && this.transaction.data.product === 'book') {
      if (this.transaction.data?.payload?.Details) {
        return this.transaction.data.payload?.Details ?? [];
      }
      if (this.transaction.data?.wager?.Details) {
        return this.transaction.data.wager?.Details ?? [];
      }
    }

    return [];
  }

  get bookPayload() {
    if (this.transaction && this.transaction.data?.product === 'book') {
      return this.transaction.data?.payload ?? null;
    }
    return null;
  }

  get bookNotifications(): any[] {
    if (this.transaction && this.transaction.data?.product === 'book') {
      return this.transaction.data?.notifications ?? [];
    }
    return [];
  }

  /**
   * Determina el resultado de la apuesta basado en las notificaciones.
   * result: 1 = Ganadora, 0 = Pendiente, otros = No Ganadora
   */
  get bookBetResult(): { label: string; color: string } {
    const notifications = this.bookNotifications;
    if (!notifications.length) {
      return { label: 'Pendiente', color: 'warning' };
    }
    // Tomamos la última notificación como resultado final
    const lastNotification = notifications[notifications.length - 1];
    if (lastNotification.result === 1) {
      return { label: 'Ganadora', color: 'success' };
    } else if (lastNotification.result === 0) {
      return { label: 'Pendiente', color: 'warning' };
    }
    return { label: 'No Ganadora', color: 'danger' };
  }

  get bookWinAmount(): number | null {
    const payload = this.bookPayload;
    if (payload) {
      return payload.winAmount ?? null;
    }
    return null;
  }

  get bookRiskAmount(): number | null {
    const payload = this.bookPayload;
    if (payload) {
      return payload.riskAmount ?? null;
    }
    return null;
  }

  get bookBetType(): string {
    const payload = this.bookPayload;
    if (payload?.description) {
      return payload.description;
    }
    if (this.bookWaggers.length) {
      return this.bookWaggers[0].description ?? '';
    }
    return '';
  }

  get bookWagerType(): number | null {
    return this.bookPayload?.WagerType ?? null;
  }

  getBookDetailEventDescription(detail: any): string {
    const home = detail.teamDescription ?? '';
    const visitor = detail.versusTeamDescription ?? '';
    if (home && visitor) {
      return `${home} vs ${visitor}`;
    }
    return home || visitor || '';
  }

  formatBookDateTime(dateStr: string): string {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateStr;
    }
  }
}
